import { BetManager } from "../../Managers/BetManager";

export class HtmlToastMessage {
    private static readonly DefaultDuration = 2000; //in ms

    private static readonly DefaultElementId = "root";

    private static DurationTimeLeft: number;

    public static readonly Position = {
        above: "above",
        top: "top",
        middle: "middle",
        bottom: "bottom",
        below: "below",
    };

    /**
     * Show toast message over element
     * @param text - text showed in toast message.
     * @param position - position of toast message based on element. Above, top, middle, bottom, below.
     * @param elementId - optional element to show message over.
     * @param duration - optional duration of toast message animation.
     */
    public static show(
        text: string,
        position: string,
        elementId: string = HtmlToastMessage.DefaultElementId,
        duration: number = HtmlToastMessage.DefaultDuration,
    ): void {
        let parent = document.getElementById(elementId);
        if (parent != null) {
            let toastMessage: HTMLElement = <HTMLElement>parent.getElementsByClassName("toastMessage")[0];
            let toastMessageText: HTMLElement;
            let parentW = parseInt(parent.style.width);
            let parentH = parseInt(parent.style.height);

            if (toastMessage == null) {
                toastMessage = document.createElement("div");
                toastMessageText = document.createElement("div");
                // toastMessageText.addEventListener("webkitAnimationEnd", HtmlToastMessage.removeToastMessage.bind(this, toastMessage));
                // toastMessageText.addEventListener("animationend", HtmlToastMessage.removeToastMessage.bind(this, toastMessage));

                toastMessage.appendChild(toastMessageText);
                parent.appendChild(toastMessage);
            } else {
                toastMessageText = <HTMLElement>toastMessage.children[0];
            }

            toastMessage.className = "";
            toastMessage.classList.add("toastMessage", position);
            toastMessageText.textContent = text;
            toastMessageText.style.animationDuration = duration + "ms";

            HtmlToastMessage.DurationTimeLeft = duration;

            // this.resizeToastMessage(toastMessage,toastMessageText);

            toastMessage.classList.remove("show");
            toastMessage.offsetWidth;
            toastMessage.classList.add("show");
        }
    }

    private static resizeToastMessage(toastMessage: HTMLElement, toastMessageText: HTMLElement): void {
        let toastMessageStyles = window.getComputedStyle(toastMessageText);

        toastMessageText.style.top =
            (parseFloat(toastMessageStyles.height) + parseFloat(toastMessageStyles.paddingTop) * 2) * 0.5 * -1 + "px";
        toastMessageText.style.left =
            (parseFloat(toastMessageStyles.width) + parseFloat(toastMessageStyles.paddingLeft) * 2) * 0.5 * -1 + "px";

        //check message visibility
        toastMessage.setAttribute("style", "");
        let toastMessagePosition = toastMessageText.getBoundingClientRect();
        if (toastMessagePosition.left < 0) {
            toastMessageText.style.left = 0 + "px";
        } else if (toastMessagePosition.right > window.innerWidth) {
            toastMessageText.style.left = parseFloat(toastMessageStyles.width) * -1 + "px";
        }

        if (toastMessagePosition.top < 0) {
            toastMessage.style.top = 0 + "px";
        } else if (toastMessagePosition.bottom > window.innerHeight) {
            toastMessage.style.top = parseFloat(toastMessageStyles.height) * -1 + "px";
        }

        if (HtmlToastMessage.DurationTimeLeft > 0) {
            setInterval(() => {
                HtmlToastMessage.DurationTimeLeft -= 100;
                this.resizeToastMessage(toastMessage, toastMessageText);
            }, 100);
        }
    }

    private static removeToastMessage(toastMessage: HTMLElement): void {
        if (toastMessage != null) {
            toastMessage.parentNode.removeChild(toastMessage);
        }
    }

    public static removeAllToastMessages(parentElementId: string = ""): void {
        let parent = document.body;
        if (parentElementId != "") {
            parent = document.getElementById(parentElementId);
        }

        while (parent.getElementsByClassName("toastMessage")[0] != null) {
            let toastMessage = parent.getElementsByClassName("toastMessage")[0];
            toastMessage.parentNode.removeChild(toastMessage);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlToastMessage.ts
 **/